
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../shared/shared-imports';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { ApiEndPoints, ApiRoot } from '../../../shared/constants/api-endpoints';
import { Utils } from '../../../Utils/utils';
import { SharedService } from '../../../shared/services/shared.service';
import { DirectoryRequest } from './models/directory-req.model';
import { TablePagenationComponent } from "../../../shared/components/table-pagenation/table-pagenation.component";
interface DirectoryRow {
  membership: string;
  name: string;
  email: string;
  phone: string;
}
@Component({
  selector: 'app-directory',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS, TablePagenationComponent],
  templateUrl: './directory.component.html',
  styleUrl: './directory.component.scss'
})
export class DirectoryComponent {

  form!: FormGroup;
  rows: DirectoryRow[] = [];
  loading: boolean = false;
  totalRecords: number = 0;
  currentPage: number = 1;
  pageSize: number = 10;
  dataFetched: boolean = false;
  lastSearchTerm: string = '';
  private directoryRequest: DirectoryRequest = new DirectoryRequest();
  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private sharedService: SharedService
  ) {
    this.form = this.fb.group({ search: [''] });
  }


  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    this.form
      .get('search')
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((term: string | null) => {
        this.getDirectoryList(term ?? '', 1);
      });

    // this.getDirectoryList();
  }

  // This method is used to fetch directory list using api
  getDirectoryList(searchTerm: string = '', page: number = 1): void {
    const normalizedTerm = searchTerm ? searchTerm.trim() : "";
    this.lastSearchTerm = normalizedTerm;
    const isArabic = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(
      normalizedTerm
    );
    this.currentPage = page;
    this.totalRecords = 0;
    this.loading = true;
    this.dataFetched = false;
    const language = this.sharedService.getCurrentLang() === 'ar' ? 'ARA' : 'ENU';
    this.directoryRequest.body.Language = language;
    this.directoryRequest.body.PageSize = String(this.pageSize);
    this.directoryRequest.body.StartRowNum = this.pageSize * (this.currentPage - 1);
    this.directoryRequest.body.NewQuery = this.currentPage === 1 ? 'true' : 'false';
    this.directoryRequest.body.IncomingHierarchy.MessageId = Utils.generateUniqueId();
    this.directoryRequest.body.IncomingHierarchy.ListOfDCAccountDirectoryIO['DC Account Thin']['DC Name English'] = !isArabic ? normalizedTerm : "";
    this.directoryRequest.body.IncomingHierarchy.ListOfDCAccountDirectoryIO['DC Account Thin']['DC Name Arabic'] = isArabic ? normalizedTerm : "";

    this.api
      .post(ApiRoot.DCCICPIntegration, ApiEndPoints.GET_COMMERCIAL_DIRECTORY, this.directoryRequest)
      .pipe(finalize(() => {
        this.loading = false;
        this.dataFetched = true;
      }))
      .subscribe({
        next: (response: any) => {
          const list =
            response?.SiebelMessage?.ListOfDCAccountDirectoryIO?.['DC Account Thin'] ??
            response?.SiebelMessage?.['DC Account Thin'] ??
            [];
          const result = Utils.checkIsArray(list);
          this.totalRecords = response?.TotalRecords ?? response?.TotalCount ?? result.length;

          this.rows = result.map((item: any) => ({
            membership: item['CSN'],
            name:
              language === 'ARA'
                ? item['DC Name Arabic'] || item['DC Name English'] || ''
                : item['DC Name English'] || item['DC Name Arabic'] || '',
            email: item['Main Email Address'],
            phone: item['Main Phone Number'],
          }));
        },
        error: () => {
          this.rows = [];
        },
      });
  }

  get totalPages() {
    return Math.ceil(this.totalRecords / this.pageSize);
  }

  // This method is used to handle page changes from pagination component
  changePage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    const currentSearch = this.form.get('search')?.value ?? '';
    this.getDirectoryList(currentSearch, page);
  }
}
